export default "__VITE_ASSET__BXwWoz3u__"